{
  "nav": {
    "items": {
      "myPage": "Ma page"
    }
  },
  "myPage": {
    "subtitle": "Votre page publique sur {{brand}} : choisissez un modèle, organisez les sections et publiez.",
    "loading": "Préparation de votre page",
    "loadFailed": "Impossible de charger votre page",
    "railLabel": "Paramètres de la page",
    "markdownHint": "Vous pouvez utiliser une mise en forme simple : # titre, **gras**, listes avec - et liens sous la forme [texte](https://…). Le HTML n’est pas accepté.",
    "markdownHintShort": "**Gras**, listes avec - et liens acceptés.",
    "tabs": {
      "label": "Sections de ma page",
      "builder": "Modifier la page",
      "leads": "Demandes reçues"
    },
    "status": {
      "draft": "Brouillon",
      "published": "Publiée",
      "unpublished": "Publication retirée",
      "suspended": "Suspendue",
      "unknown": "Inconnu"
    },
    "statusCard": {
      "title": "Statut de la page",
      "liveUrl": "Adresse de votre page",
      "futureUrl": "Une fois publiée, la page sera accessible à cette adresse",
      "copy": "Copier l’adresse",
      "copied": "Adresse copiée",
      "copyFailed": "Impossible de copier l’adresse",
      "lastPublished": "Dernière publication : {{date}}",
      "preview": "Aperçu",
      "openPreview": "Ouvrir l’aperçu",
      "popupBlocked": "Le navigateur a bloqué la fenêtre d’aperçu ; utilisez le lien ci-dessous.",
      "publish": "Publier",
      "republish": "Publier les modifications",
      "unpublish": "Retirer la publication",
      "unpublishTitle": "Retirer la publication de la page ?",
      "unpublishBody": "La page est retirée d’internet et son adresse ne s’ouvre plus. Tout le contenu est conservé et vous pourrez la publier à nouveau.",
      "unpublishConfirm": "Retirer la publication",
      "unpublished": "La page n’est plus publiée",
      "unpublishFailed": "Le retrait de la publication a échoué. Réessayez.",
      "blockersTitle": "Pour publier, complétez les éléments suivants :",
      "addCouncil": "Ajoutez votre numéro d’inscription à l’Ordre dans votre profil"
    },
    "banner": {
      "suspendedTitle": "Votre page a été suspendue par {{brand}}",
      "suspendedNoReason": "Aucun motif n’a été indiqué.",
      "suspendedSupport": "La page est en lecture seule. Contactez l’assistance {{brand}} pour lever la suspension.",
      "unpublishedChanges": "Vous avez des modifications non encore publiées ; les visiteurs voient la version précédente."
    },
    "save": {
      "save": "Enregistrer",
      "reset": "Réinitialiser",
      "saving": "Enregistrement…",
      "saved": "Enregistré",
      "dirty": "Modifications non enregistrées"
    },
    "publish": {
      "title": "Publier la page",
      "intro": "Une fois publiée, votre page est visible par tous sur internet et peut apparaître dans les résultats de recherche. Avant de publier, confirmez les points suivants :",
      "rule1": "Le contenu respecte les règles de l’Ordre des médecins en matière de publicité et ne contient aucune promesse de guérison certaine ou de résultat garanti, ni aucune comparaison avec des confrères.",
      "rule2": "Les images et les textes vous appartiennent, ou vous avez l’autorisation de les utiliser.",
      "rule3": "Les témoignages de patients sont publiés avec leur consentement, et la page ne contient aucune information médicale personnelle.",
      "rule4": "Vous êtes responsable du contenu de la page, et {{brand}} peut suspendre une page qui ne respecte pas ces règles.",
      "public": "La page est publique : toute personne qui connaît son adresse peut la consulter, de même que les moteurs de recherche.",
      "accept": "J’ai lu et j’accepte ces conditions",
      "confirm": "Publier",
      "cancel": "Annuler",
      "failedTitle": "La publication a échoué ; corrigez les points suivants",
      "done": "Votre page a été publiée"
    },
    "template": {
      "title": "Modèle"
    },
    "templates": {
      "classic": {
        "name": "Classique",
        "description": "Sobre, d’allure imprimée : un portrait encadré, un grand titre dont la seconde partie est mise en valeur, l’image de fond en bandeau en haut de la page et une barre de points forts."
      },
      "modern": {
        "name": "Moderne",
        "description": "Comme la page d’accueil du site d’une clinique : un grand titre, une image de fond, des cartes à côté de votre photo et un bandeau de points forts."
      },
      "minimal": {
        "name": "Minimaliste",
        "description": "Typographique et aéré, sans image de couverture ; centré sur le texte, les prestations et les articles."
      }
    },
    "palettes": {
      "azure": "Azur",
      "teal": "Turquoise",
      "deep": "Bleu marine",
      "brand": "Couleurs {{brand}}",
      "cyan": "Cyan",
      "ink": "Encre"
    },
    "theme": {
      "title": "Couleur et densité",
      "palette": "Palette",
      "density": "Densité",
      "densities": {
        "comfortable": "Confortable",
        "compact": "Compacte"
      },
      "onlyTemplate": "Seules les palettes et densités compatibles avec le modèle actuel sont affichées."
    },
    "slug": {
      "label": "Adresse de la page",
      "hint": "Lettres latines minuscules sans accents, chiffres et tirets ; de 3 à 40 caractères. Par défaut : votre numéro d’inscription à l’Ordre.",
      "lockedHint": "L’adresse a été fixée lors de la première publication et ne peut plus être modifiée.",
      "required": "Saisissez une adresse.",
      "invalid": "Uniquement des lettres latines minuscules sans accents, des chiffres et des tirets, de 3 à 40 caractères ; l’adresse doit commencer et se terminer par une lettre ou un chiffre, sans double tiret.",
      "checking": "Vérification…",
      "available": "Cette adresse est disponible.",
      "taken": "Cette adresse n’est pas disponible.",
      "save": "Enregistrer l’adresse"
    },
    "sections": {
      "title": "Sections",
      "reorderHint": "Modifiez l’ordre avec les boutons haut et bas (ou Alt et les touches fléchées).",
      "kinds": {
        "hero": "Profil professionnel",
        "services": "Prestations",
        "articles": "Articles",
        "testimonials": "Sélection de témoignages de patients",
        "gallery": "Galerie d’images",
        "video": "Vidéo",
        "office": "Informations sur le cabinet",
        "booking": "Prise de rendez-vous"
      },
      "show": "Afficher « {{name}} » sur la page",
      "shown": "Affichée",
      "hidden": "Masquée",
      "hiddenNotice": "Cette section est masquée et n’apparaît pas sur votre page publique.",
      "showOnPage": "Afficher sur la page",
      "toggleFailed": "Impossible de modifier l’affichage de « {{name}} » :",
      "required": "Cette section est toujours affichée",
      "moveUp": "Monter « {{name}} »",
      "moveDown": "Descendre « {{name}} »",
      "unsupported": "Non affichée dans ce modèle",
      "unsupportedLong": "Le modèle actuel n’affiche pas cette section. Son contenu est conservé et réapparaîtra si vous changez de modèle.",
      "hasErrors": "Cette section bloque la publication",
      "titleOverride": "Titre de la section (facultatif)",
      "titleOverrideHint": "Laissez vide pour afficher le titre par défaut.",
      "reorderFailed": "L’ordre des sections n’a pas été enregistré. Réessayez.",
      "booking": {
        "intro": "Un visiteur peut choisir un créneau libre dans l’une de vos cliniques ou simplement demander à être rappelé. C’est la clinique qui décide si une prestation est publique et réservable directement.",
        "enabled": "Afficher la prise de rendez-vous sur la page",
        "enabledHint": "Désactivée, seule la demande de rappel reste sur la page.",
        "clinic": "Clinique",
        "clinicPlaceholder": "Choisir une clinique",
        "clinicSingleHint": "La seule clinique dont vous êtes membre.",
        "noClinicsTitle": "Vous devez être membre d’une clinique pour proposer la prise de rendez-vous",
        "noClinicsBody": "Les adhésions se gèrent dans « Cliniques », dans les paramètres.",
        "goClinics": "Cliniques",
        "mode": "Mode de prise de rendez-vous",
        "modes": { "slots": "Choisir un créneau libre", "request": "Demande de rappel uniquement" },
        "modeHints": {
          "slots": "Le visiteur voit vos créneaux libres et réserve après s’être connecté à l’application patient.",
          "request": "Seul le formulaire de demande de rappel est affiché."
        },
        "services": "Prestations",
        "servicesHint": "Seules les prestations rendues publiques par la clinique sont proposées. Une prestation « sur orientation du médecin » porte ce badge et ne peut pas être réservée directement par un visiteur.",
        "servicesEmpty": "Cette clinique n’a pas encore de prestation publique pour vous.",
        "kinds": { "direct": "Réservation directe", "referral": "Sur orientation du médecin" },
        "duration": "{{minutes}} min",
        "unavailable": "N’est plus publique",
        "unavailableHint": "Une prestation qui n’est plus publique est retirée à l’enregistrement.",
        "horizon": "Jours affichés",
        "horizonDays": "{{days}} jours",
        "horizonHint": "Les créneaux libres sont affichés sur ce nombre de jours à venir.",
        "previewNote": "Les créneaux libres s’affichent sur la page publiée.",
        "loadFailed": "Les options de prise de rendez-vous n’ont pas pu être chargées",
        "errors": {
          "BOOKING_CLINIC_REQUIRED": "Choisissez une clinique.",
          "BOOKING_CLINIC_NOT_MEMBER": "Vous n’êtes plus membre de cette clinique ; choisissez-en une autre.",
          "BOOKING_SERVICES_REQUIRED": "Choisissez au moins une prestation.",
          "BOOKING_SERVICE_UNAVAILABLE": "Certaines prestations choisies ne sont plus publiques et seront retirées à l’enregistrement."
        }
      }
    },
    "items": {
      "count": "{{count}} sur {{max}}",
      "moveUp": "Monter",
      "moveDown": "Descendre",
      "remove": "Supprimer"
    },
    "image": {
      "pick": "Choisir une image",
      "replace": "Changer d’image",
      "remove": "Retirer l’image",
      "removeTitle": "Retirer l’image ?",
      "removeBody": "L’image est retirée de la page. Après la prochaine publication, elle sera aussi retirée de la page publique.",
      "removeConfirm": "Retirer",
      "cropTitle": "Recadrer l’image",
      "typeUnsupported": "Seules les images JPEG ou PNG sont acceptées.",
      "tooLarge": "L’image dépasse 5 Mo.",
      "readFailed": "Impossible de lire le fichier."
    },
    "hero": {
      "displayName": "Nom affiché",
      "displayNameRequired": "Le nom affiché est obligatoire.",
      "headline": "Accroche",
      "headlinePlaceholder": "ex. : cardiologue, enseignant à la faculté de médecine",
      "headlineHint": "Dans les modèles « Moderne » et « Classique », ce texte s’affiche en grand en haut de la page ; s’il contient une virgule, la partie qui suit s’affiche en couleur.",
      "about": "À propos de moi",
      "portrait": "Portrait",
      "portraitHint": "Une copie distincte de votre photo de profil ; la modifier n’a aucun effet sur votre profil.",
      "cover": "Image de fond",
      "coverHint": "Une image large (format 3:1 environ). Le modèle « Moderne » l’affiche estompée derrière le haut de la page ; le modèle « Classique », en bandeau en haut de la page.",
      "coverUnused": "Le modèle actuel n’affiche pas d’image de fond ; choisissez « Moderne » ou « Classique » pour la voir.",
      "extras": {
        "onlyModern": "Ces deux listes s’affichent dans les modèles « Moderne » et « Classique ». Si elles restent vides, vos premières prestations ainsi que votre numéro d’inscription à l’Ordre, votre ville et les horaires du cabinet s’affichent à leur place.",
        "notShown": "Le modèle actuel n’affiche pas ces deux listes ; choisissez « Moderne » ou « Classique » pour les voir.",
        "cardsTitle": "Cartes de présentation",
        "cardsHint": "Jusqu’à deux cartes courtes en haut de la page, par exemple « Consultations en présentiel et en ligne ».",
        "addCard": "Ajouter une carte",
        "highlightsTitle": "Points forts",
        "highlightsHint": "Jusqu’à trois éléments dans le bandeau sous le haut de la page, par exemple « 15 ans d’expérience ».",
        "addHighlight": "Ajouter un point fort",
        "itemTitle": "Titre",
        "itemText": "Texte court (facultatif)",
        "titleRequired": "Le titre est obligatoire."
      }
    },
    "services": {
      "itemTitle": "Titre de la prestation",
      "itemDescription": "Description",
      "image": "Image de la prestation",
      "imageHint": "Format 4:3 ; le titre de la prestation sert de texte alternatif à l’image.",
      "imageAfterSave": "Vous pourrez ajouter une image après avoir enregistré cette prestation.",
      "add": "Ajouter une prestation"
    },
    "testimonials": {
      "framingTitle": "Des témoignages choisis, pas des évaluations",
      "framing": "Cette section contient des citations que vous choisissez et saisissez vous-même, affichées sous le titre « Sélection de témoignages de patients ». La page n’affiche ni note, ni étoiles, ni nombre d’avis.",
      "text": "Témoignage",
      "attribution": "Nom affiché du patient",
      "attributionPlaceholder": "ex. : « Maryam R. » ou « patient de 45 ans »",
      "consent": "Le patient a accepté la publication de ce témoignage sur la page publique",
      "consentRequired": "Ce témoignage ne peut pas être enregistré sans confirmation du consentement du patient.",
      "add": "Ajouter un témoignage"
    },
    "video": {
      "intro": "Collez l’adresse d’une vidéo Aparat ou YouTube ; seul l’identifiant de la vidéo est enregistré.",
      "url": "Adresse de la vidéo",
      "caption": "Légende courte",
      "add": "Ajouter une vidéo",
      "pending": "Vérifiée à l’enregistrement",
      "aparat": "Aparat",
      "youtube": "YouTube"
    },
    "gallery": {
      "alt": "Texte alternatif",
      "altRequired": "Le texte alternatif est obligatoire.",
      "saveAlt": "Enregistrer le texte",
      "newAlt": "Description de la nouvelle image",
      "newAltPlaceholder": "ex. : « Salle d’attente du cabinet »",
      "altFirst": "Rédigez d’abord la description de l’image.",
      "emptyTitle": "Aucune image dans la galerie pour l’instant",
      "emptyHint": "Ajoutez jusqu’à 12 images de votre cabinet et de vos équipements."
    },
    "articles": {
      "new": "Nouvel article",
      "back": "Retour aux articles",
      "title": "Titre de l’article",
      "slug": "Adresse de l’article (facultatif)",
      "slugHint": "Laissez vide pour la générer à partir du titre. Elle est fixée lors de la première publication.",
      "slugLocked": "Adresse de l’article :",
      "body": "Texte de l’article",
      "cover": "Image de l’article",
      "publish": "Publier l’article",
      "unpublish": "Repasser en brouillon",
      "republish": "Publier les modifications de l’article",
      "delete": "Supprimer l’article",
      "deleteTitle": "Supprimer l’article ?",
      "deleteBody": "L’article « {{title}} » sera définitivement supprimé.",
      "deleteConfirm": "Supprimer",
      "saveFirst": "Enregistrez vos modifications avant de publier.",
      "saveToContinue": "Après l’enregistrement, vous pourrez ajouter une image et publier l’article.",
      "untitled": "Sans titre",
      "publishedOn": "Publié le {{date}}",
      "neverPublished": "Pas encore publié",
      "statusPublished": "Publié",
      "statusDraft": "Brouillon",
      "changed": "Modifications non publiées",
      "emptyTitle": "Vous n’avez encore écrit aucun article",
      "emptyHint": "Les articles pédagogiques destinés aux patients rendent votre page plus facile à trouver dans les moteurs de recherche."
    },
    "office": {
      "intro": "Ce que vous saisissez ici s’affiche tel quel sur la page publique.",
      "phones": "Téléphones",
      "phoneLabel": "Libellé",
      "phoneLabelPlaceholder": "ex. : secrétariat",
      "phoneNumber": "Numéro",
      "addPhone": "Ajouter un téléphone",
      "city": "Ville",
      "address": "Adresse du cabinet",
      "hours": "Horaires du cabinet",
      "hoursLabel": "Jours",
      "hoursLabelPlaceholder": "ex. : du samedi au mercredi",
      "hoursValue": "Horaires",
      "hoursValuePlaceholder": "ex. : de 16 h à 20 h",
      "addHours": "Ajouter des horaires",
      "geo": "Emplacement sur la carte (facultatif)",
      "geoHint": "Indiquez votre cabinet sur la carte pour que les patients puissent obtenir l’itinéraire depuis votre page avec Neshan, Balad ou Google Maps.",
      "map": {
        "pick": "Choisir sur la carte",
        "change": "Modifier sur la carte",
        "close": "Fermer la carte",
        "myLocation": "Ma position actuelle",
        "clear": "Supprimer l’emplacement",
        "isSet": "Votre cabinet est indiqué sur la carte.",
        "label": "Carte pour choisir l’emplacement du cabinet",
        "hint": "Touchez la carte ou faites glisser le repère sur votre cabinet, puis appuyez sur « Enregistrer ».",
        "found": "Le repère est placé sur votre position actuelle. Si vous n’êtes pas au cabinet en ce moment, déplacez-le sur le cabinet.",
        "locating": "Recherche de votre position…",
        "loading": "Chargement de la carte…",
        "failed": "Impossible de charger la carte. Si vous êtes au cabinet, appuyez sur « Ma position actuelle ».",
        "denied": "L’accès à votre position n’a pas été autorisé ; touchez la carte pour indiquer votre cabinet.",
        "unavailable": "Votre position est introuvable ; touchez la carte pour indiquer votre cabinet.",
        "timeout": "La recherche de votre position a pris trop de temps ; réessayez ou touchez la carte.",
        "unsupported": "Ce navigateur ne permet pas de partager une position ; touchez la carte pour indiquer votre cabinet."
      },
      "socials": "Réseaux sociaux",
      "socialsHint": "Saisissez l’identifiant ou l’adresse du profil (ex. : @dr.example ou instagram.com/dr.example). WhatsApp : le numéro complet avec l’indicatif du pays. Site web : l’adresse complète.",
      "social": {
        "instagram": "Instagram",
        "telegram": "Telegram",
        "whatsapp": "WhatsApp",
        "eitaa": "Eitaa",
        "bale": "Bale",
        "website": "Site web"
      }
    },
    "leads": {
      "intro": "Demandes envoyées par les visiteurs depuis votre page. Leur suivi est assuré par l’équipe {{brand}}.",
      "name": "Nom",
      "mobile": "Portable",
      "preference": "Préférence de contact",
      "message": "Message",
      "createdAt": "Reçue le",
      "status": "Statut",
      "more": "Afficher plus",
      "loadFailed": "Impossible de charger les demandes",
      "emptyTitle": "Aucune demande pour l’instant",
      "emptyHint": "Communiquez l’adresse de votre page à vos patients pour qu’ils puissent vous contacter via « Demander un rendez-vous ».",
      "notPublishedTitle": "La page n’est pas encore publiée",
      "notPublishedHint": "Une fois la page publiée, les demandes des visiteurs s’affichent ici.",
      "channels": {
        "call": "Appel téléphonique",
        "sms": "SMS",
        "whatsapp": "WhatsApp"
      },
      "times": {
        "morning": "Matin",
        "afternoon": "Après-midi",
        "evening": "Soir",
        "any": "À tout moment"
      },
      "statuses": {
        "new": "Nouvelle",
        "contacted": "Contact pris",
        "qualified": "En cours",
        "proposal": "En cours",
        "negotiation": "En cours",
        "won": "Traitée",
        "lost": "Clôturée"
      }
    }
  }
}
